import { render, staticRenderFns } from "./ProtectionAreaCard.vue?vue&type=template&id=0dd9309f"
import script from "./ProtectionAreaCard.vue?vue&type=script&lang=js"
export * from "./ProtectionAreaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports